var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-module-column flex-grow",class:{'flex-column': _vm.enableFlex},style:({'min-width': _vm.parsePixel(_vm.width), 'max-width': _vm.parsePixel(_vm.width), 'overflow': _vm.scroll ? 'auto' : 'initial'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }